import LineOfCreditEntryPoint from 'features/lineOfCredit/screens/lineOfCreditEntryPoint/LineOfCreditEntryPoint';
import React from 'react';

export default function Page() {
  return <LineOfCreditEntryPoint />;
}
